module.exports = __webpack_public_path__ + "img/testimonial-gergely.4f5f38df.png";